import keyMirror from "keymirror";

export const model = keyMirror({
	USER: null,
	INSTITUTION: null,
});
